import React from "react";
import {
  ASkeleton,
  ASkeletonBlock,
  ASkeletonText
} from "@cisco-sbg-ui/magna-react";

const AppSkeleton = () => (
  <>
    <ASkeleton header hidePanelBackdrop className="mt-3" />
    <ASkeleton hidePanelBackdrop>
      <ASkeletonBlock />
    </ASkeleton>
    <ASkeleton header className="pa-4">
      {new Array(10).fill(0).map((_, i) => (
        <ASkeletonText className="my-3" key={`${i}-text-row`} />
      ))}
    </ASkeleton>
  </>
);

export default AppSkeleton;
